import { render, staticRenderFns } from "./fkPC.vue?vue&type=template&id=3309dcda&scoped=true&"
import script from "./fkPC.vue?vue&type=script&lang=js&"
export * from "./fkPC.vue?vue&type=script&lang=js&"
import style0 from "./fkPC.vue?vue&type=style&index=0&id=3309dcda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3309dcda",
  null
  
)

export default component.exports